import * as React from 'react';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import FormItem from 'antd/lib/form/FormItem';
import withStyles from 'react-jss';
import SearchTagsInput from 'src/components/common/SearchTagsInput';
import Form, { FormComponentProps } from 'antd/lib/form';
import { Product } from './Product.interface';
import { commonStyles } from 'src/Library/CommonStyles';
import { ProductFormLabels } from './Product.Helper';
import { searchStakeholder } from 'src/api/masters';
import { useGenericState } from 'src/Library/UseGenericState';
import { StylesProps, KeyLabel } from 'src/Library/Types';
import {
  searchProductMaster,
  editProduct,
  createProduct,
} from './Product.api';
import { isValidArray } from 'src/Library/Helper';
import { AutoComplete } from 'antd';
import Asterisk from 'src/components/common/Asterisk';

const NewProduct = (props: IProps) => {
  const {
    form,
    classes,
    product,
    handleClose,
    type,
  } = props;

  const [state, setState] = useGenericState<StateProps>({
    masterProductList: [],
    supplierList: [],
    customerList: [],
    shipperList: [],
  });

  const {
    supplierList,
    customerList,
    creating,
    shipperList,
    masterProductList,
  } = state;

  const [value, setValue] = React.useState('');
  const [isSelected, setIsSelected] = React.useState(false);
  const [isNewHscode, setisNewHscode] = React.useState(false);

  function handleSubmit() {
    if (!(/^[a-zA-Z0-9]*$/.test(form.getFieldValue('newUnit')))){
      message.error('Measurement Unit must be alpha numeric');
    }
    form.validateFields((err, values) => {
      if (err) return;
      handleApi(values);
    });
  }

  function getKeys(item) {
    if (!isValidArray(item)) return [];
    return item.map(x => (x.key));
  }

  async function handleApi(values) {
    const {
      internalName,
      remark,
      skuCode,
      customer,
      supplier,
      shipper,
    } = values;
    const apiCallObject = {
      id: product?.id,
      remark,
      internalName,
      skuCode,
      productMasterId: isSelected ? values.productMasterId : undefined,
      customerIdList: getKeys(customer),
      shipperIdList: getKeys(shipper),
      supplierIdList: getKeys(supplier),
      newHSCode: isSelected ? null : {
        "hsCode" : form.getFieldValue('newCode'),
        "name" : form.getFieldValue('newDescription'), 
        "measurementUnit" : form.getFieldValue('newUnit')},
    };
    if (isSelected){
      setIsSelected(false);
    }
    let response;
    setState({ creating: true });
    isSelected && setIsSelected(true);
    if (product?.id) response = await editProduct(apiCallObject);
    else response = await createProduct(apiCallObject);
    setState({ creating: false });
    if (response.isSuccess) {
      message.success(`Product ${(product?.id && 'Updated') || 'Created'} successfully`);
      handleClose(true);
    } else {
      message.error(response.errorMessage);
    }
  }

  async function handleSupplierSearch(queryString) {
    const params = { type: 'SUPPLIER', queryString };
    const response = await searchStakeholder(params);
    setState({
      supplierList: (response?.data || []).map(item => ({
        key: item.org2Id,
        label: item.name
      })),
    });
  }

  async function handleCustomerSearch(queryString) {
    const params = { type: 'CUSTOMER', queryString };
    const response = await searchStakeholder(params);
    setState({
      customerList: (response?.data || []).map(item => ({
        key: item.org2Id,
        label: item.name
      })),
    });
  }

  async function handleShipperSearch(queryString) {
    const params = { type: 'SHIPPER', queryString };
    const response = await searchStakeholder(params);
    setState({
      shipperList: (response?.data || []).map(item => ({
        key: item.org2Id,
        label: item.name
      })),
    });
  }

  async function searchProductMasters(queryString: string) {
    const response = await searchProductMaster({ queryString, limit:100});
    setState({
      masterProductList: (response?.data || []).map(item => ({
        ...item,
        key: item.productMasterId,
        label: item.product,
      })),
    });
  }

  const renderLabel = (key: string, required = false) => {
    return <div
      className={classes.label}>
      <span>{ProductFormLabels[key]}</span>
      {required && <Asterisk />}
    </div>;
  };

  const renderProductName = () => {
    return <FormItem
      className={classes.formItem}>
      {renderLabel('internalName')}
      {form.getFieldDecorator('internalName', {
        rules: [
          { required: true, message: 'Required' },
          { max: 50, message: 'Max Length: 50' }
        ],
        initialValue: product?.internalName,
      })(<Input
        max={50}
        style={{ width: '75%', marginLeft: 12 }}
        placeholder="Product"
      />)}
    </FormItem>;
  };

  const onSelect = (val, option) => {
    if (!isSelected)
    {
      form.setFieldsValue({ remark: option?.props?.name })
    }
    setIsSelected(true);
  };

  const onChange = (data: string) => {
    setValue(data);
    if (!data)
      form.setFieldsValue({ remark: data});
    setIsSelected(false);
  };

  const renderHsCode = () => {
    if (isNewHscode) return;
    return <FormItem
      className={classes.formItem}>
      {renderLabel('productMasterId', true)}
      {form.getFieldDecorator('productMasterId', {
        rules: [{ required: true, message: 'Required' }],
        initialValue: product ? {
          ...product,
          key: product?.productMasterId,
          label: product?.hsCode,
        } : undefined,
      })
      (
        <AutoComplete
          value={value}
          style={{  width: '75%', marginLeft: 12 }}
          onSelect={onSelect}
          onSearch={searchProductMasters}
          onChange={onChange}
          placeholder="Search Product Master"
        >
          {masterProductList?.map((product) => (
            <AutoComplete.Option
              // key={product.key}
              {...product}
            >
              {product.label}
            </AutoComplete.Option>
          ))}
        </AutoComplete>
      )}
    </FormItem>;
  };

  const renderNewHSCode = () => {
    if (isSelected) return;
    return <FormItem className={classes.formItem}>
      {product ? renderLabel('hsCode') :renderLabel('newHsCode')}
      {form.getFieldDecorator('newCode', {
        rules: [{ required: true, message: 'Required'}],
        initialValue: product ? product.hsCode : undefined
      })
      (
        <Input
        disabled = {product ? true : false}
        type = {"number"}
        onChange={(event)=>{
          if (!event.target.value)
            setisNewHscode(false);
          else
            setisNewHscode(true);
        }}
        max={50}
        style={{ width: '20%', marginLeft: 12 , }}
        placeholder="HS Code"
      />
      )
      }
      {form.getFieldDecorator('newDescription', {
        initialValue: product ? product.remark : undefined
      })
      (
        <Input
        disabled = {product ? true : false}
        max={50}
        style={{ width: '30%', marginLeft: 12 }}
        placeholder="Name"
      />
      )
      }
      {form.getFieldDecorator('newUnit', {
        rules: [{ required: false, 
          pattern: new RegExp(/^[a-zA-Z0-9]*$/),
          message: 'Required'}],
        initialValue: product ? product.measurementUnit : undefined
      })
      (
        <Input
        disabled = {product ? true : false}
        max={50}
        style={{ width: '20%', marginLeft: 12 }}
        placeholder="Unit"
      />
      )
      }
    </FormItem>
  }

  const renderSkuCode = () => {
    return <FormItem
      className={classes.formItem}>
      {renderLabel('skuCode', false)}
      {form.getFieldDecorator('skuCode', {
        initialValue: product?.skuCode,
      })(<Input
        style={{ width: '75%', marginLeft: 12 }}
        placeholder="SKU Code"
      />)}
    </FormItem>;
  };

  const renderRemark = () => {
    return <FormItem
      className={classes.formItem}>
      {renderLabel('remark', false)}
      {form.getFieldDecorator('remark', {
        initialValue: product?.remark,
      })(<Input.TextArea
        style={{ width: '75%', marginLeft: 12 }}
        placeholder="Description"
      />)}
    </FormItem>;
  };

  function getInitialValue(arr) {
    if (isValidArray(arr)) {
      return arr.map(item => ({
        key: item.value,
        label: item.key,
      }));
    }
    return undefined;
  }

  const renderCustomer = () => {
    if (type !== 'SHIPPER') return null;
    return <FormItem
      className={classes.formItem}>
      {renderLabel('customer', false)}
      {form.getFieldDecorator('customer', {
        initialValue: getInitialValue(product?.stakeholdermapping?.customer),
      })(<SearchTagsInput
        style={{ width: '75%', marginLeft: 12 }}
        placeholder="Select Customer"
        mode="multiple"
        searchFunction={handleCustomerSearch}
        options={customerList}
        />)}
    </FormItem>;
  };

  const renderSupplier = () => {
    if (type !== 'SHIPPER') return null;
    return <FormItem
      className={classes.formItem}>
      {renderLabel('supplier', false)}
      {form.getFieldDecorator('supplier', {
        initialValue: getInitialValue(product?.stakeholdermapping?.supplier),
      })(<SearchTagsInput
        style={{ width: '75%', marginLeft: 12 }}
        searchFunction={handleSupplierSearch}
        placeholder="Select Supplier"
        options={supplierList}
        mode="multiple"
      />)}
    </FormItem>;
  };

  const renderShipper = () => {
    if (type !== 'FF') return null;
    return <FormItem
      className={classes.formItem}>
      {renderLabel('shipper', false)}
      {form.getFieldDecorator('shipper', {
        initialValue: getInitialValue(product?.stakeholdermapping?.shipper),
      })(<SearchTagsInput
        style={{ width: '75%', marginLeft: 12 }}
        searchFunction={handleShipperSearch}
        placeholder="Select Shipper"
        options={shipperList}
        mode="multiple"
      />)}
    </FormItem>;
  };

  const renderForm = () => {
    return <Form>
      {renderProductName()}
      {!product && renderHsCode()}
      {renderNewHSCode()}
      {renderSkuCode()}
      {renderRemark()}
      {renderCustomer()}
      {renderSupplier()}
      {renderShipper()}
    </Form>;
  };

  return <Modal
    visible
    closable
    width={600}
    onCancel={() => handleClose(false)}
    className={classes.mainDiv}
    okText={product? 'Submit' : 'Add'}
    title={product? 'Edit Product' : 'Add Product'}
    onOk={handleSubmit}
    confirmLoading={creating}
  >
    {renderForm()}
  </Modal>;
};

interface StateProps {
  creating?: boolean;
  supplierList: KeyLabel[];
  customerList: KeyLabel[];
  shipperList: KeyLabel[];
  masterProductList: KeyLabel[];
}
interface IProps extends FormComponentProps, StylesProps<ReturnType<typeof styles>> {
  product: Product;
  type: string;
  handleClose: (success?) => void;
}

const styles = theme => ({
  mainDiv: {
    padding: 12,
    zIndex: 100000,
  },
  label: {
    ...commonStyles(theme).flexRow,
    width: '18%',
    color: '#262626',
    fontFamily: "Open Sans",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '20px',
  },
  formItem: {
    '& .ant-form-item': {
      marginBottom: 12,
    },
    '& .ant-form-item-children': {
      ...commonStyles(theme).flexRow,
      width: '100%',
    },
    '& .ant-form-explain': {
      marginLeft: '20%',
    },
  },
});

const NewProductForm = Form.create<IProps>()(NewProduct);
export default React.memo(withStyles(styles)(NewProductForm));
